<template>
    <ul :id="`tree-node-actions-${nodo.id}`">
      <li>
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mEditionMapPathTreeNodeActionsEditor.actions.editName')"
          href="#"
          @click.prevent="$modal.showModal('MoleculeEditionAssetContentsModalEditName'
            , { 'version': contenido, 'node': nodo })"
        >
          <i class="far fa-pencil-alt"></i>
        </a>
      </li>
      <li>
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mEditionMapPathTreeNodeActionsEditor.actions.editContent')"
          href="#"
          @click.prevent="editNode"
        >
          <i class="far fa-file-alt"></i>
        </a>
      </li>
      <li v-if="!parent">
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mEditionMapPathTreeNodeActionsEditor.actions.createStep')"
          href="#"
          @click.prevent="$modal.showModal('MoleculeEditionMapPathModalCreateStep'
            , { 'version': contenido, 'padre': nodo.id })"
        >
          <i class="far fa-plus"></i>
        </a>
      </li>
      <li>
        <a
          class="a-tooltip-primary a-tooltip-bottom delete-content-action"
          :data-tooltip-text="$t('mEditionMapPathTreeNodeActionsEditor.actions.deleteContent')"
          href="#"
          @click.prevent="$modal.showModal('MoleculeEditionMapPathModalDelete'
            , { nodo: nodo, parent: parent })"
        >
          <i class="far fa-trash-alt"></i>
        </a>
      </li>
    </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionMapPathTreeNodeActionsEditor',

  props: {
    contenido: {
      type: Object,
      default: null
    },

    nodo: {
      type: Object,
      default: null
    },

    parent: {
      type: Object,
      default: null
    }
  },

  computed: {
    nodeLength () {
      return this.nodo.children ? this.nodo.children.length : 0
    }
  },

  methods: {
    editNode () {
      // TODO: reemplazar hack por funcionalidad en MoleculeContentEditor.vue
      // que no permita cambiar de nodo sin haber guardado/cancelado los cambios pendientes
      let selectedNode = Object.assign({}, this.$store.getters.getAssetSelectedNode)

      let pickedColor = Object.assign({}, this.$store.getters.getEditorPickedColor)
      if (pickedColor.id === selectedNode.id && pickedColor.color !== selectedNode.color) {
        this.$store.commit('setEditorPickedColor', {
          color: selectedNode.color,
          id: selectedNode.id
        })
      }

      let pickedColorNombre = Object.assign({}, this.$store.getters.getEditorPickedColorNombre)
      if (pickedColorNombre.id === selectedNode.id && pickedColorNombre.colorNombre !== selectedNode.colorNombre) {
        this.$store.commit('setEditorPickedColorNombre', {
          colorNombre: selectedNode.colorNombre,
          id: selectedNode.id
        })
      }

      let pickedIcon = Object.assign({}, this.$store.getters.getEditorPickedIcon)
      if (pickedIcon.id === selectedNode.id && pickedIcon.icon !== selectedNode.icono) {
        this.$store.commit('setEditorPickedIcon', {
          icon: selectedNode.icono,
          id: selectedNode.id
        })
      }

      this.$store.commit('setAssetSelectedNode', Object.assign({}, this.nodo))
    }
  }
}
</script>
